// Models
import { ChannelOptions, LineStyle } from '.';
import { LineStyleOption } from '../../../shared/models';
import { UnitPeriodChannelDto } from './unit-period-channel-dto.model';

export class UserUnitPeriodChannelDto {
	id?: number;
	jobId: number;
	colorHex?: string;
	minY?: number;
	maxY: number;
	highDanger?: number;
	highWarning?: number;
	lowDanger?: number;
	lowWarning?: number;
	options?: ChannelOptions;
	lineStyle?: LineStyle;
	lineWeight?: number;
	display?: boolean;
	showGraph?: boolean;
	seq: number;
	unitPeriodChannel: UnitPeriodChannelDto;
	unitPeriodChannelId?: number;
	lineStyleOption?: LineStyleOption;
}
